import { NavLink } from 'react-router-dom';
import '../styles/Popup.scss';

type PopupItem = {
  id: string;
  title: string;
  navLink: string;
};

type PopupProps = {
  menuItems: Array<PopupItem>;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
};

const Popup: React.FC<PopupProps> = (props) => {
  return (
    <div className="popup-inner">
      {props.menuItems.map((menu) => (
        <NavLink
          key={menu.id}
          className="popup-menu-item"
          to={menu.navLink}
          data-id={menu.id}
          onClick={props.onClick}
        >
          {menu.title}
        </NavLink>
      ))}
    </div>
  );
};

export default Popup;
